import { Fragment, HTMLAttributes } from 'react';
import { Breadcrumb, BreadcrumbProps } from '../../atoms/breadcrumb/breadcrumb';
import { twMerge } from 'tailwind-merge';
import { Breadcrumbs as AriaBreadcrumbs } from 'react-aria-components';

export type BreadcrumbsProps = {
  crumbs: Array<BreadcrumbProps>;
} & HTMLAttributes<HTMLDivElement>;

export function Breadcrumbs(props: BreadcrumbsProps) {
  const { crumbs, className, ...rest } = props;

  return (
    <AriaBreadcrumbs
      className={twMerge('flex flex-row space-x-12', className)}
      {...rest}
    >
      {crumbs.map((crumb, key) => (
        <Fragment key={`breadcrumb-${key}`}>
          <Breadcrumb {...crumb} />
        </Fragment>
      ))}
    </AriaBreadcrumbs>
  );
}
